import React from 'react';

import { useClassroomContext } from '../../Context/ClassroomContext';

const useClassroomSession = () => {
  const {
    hasClassroomSession,
    initClassroom,
    courseData,
    classroomCourseId,
    isUnauthorizedUser,
    logoutCallback,
  } = useClassroomContext();

  return {
    enterClassroom: initClassroom,
    hasClassroomSession,
    courseData,
    classroomCourseId,
    isUnauthorizedUser,
    logoutCallback,
  };
};
export default useClassroomSession;
